import React from 'react'

const Footer = () => {
	return (
		<h1 className="footer">By the creators Eleanor & George</h1>
	)
}

export default Footer